export default {
  step4: [
    {
      id:21,
      step: 4,
      stepJp:"表面の仕上げ",
      name: "光沢",
      property: "surface",
      val: "gloss",
      summary:"艶感のある仕上げ。テクスチャーのナチュラルな風合いが最も生きてきます。\n" +
        "リング内側は鏡面仕上げとなります。（シンプル以外は磨き直しできません）",
    },
    {
      id:22,
      step: 4,
      stepJp:"表面の仕上げ",
      name: "ヘアライン",
      property: "surface",
      val: "hairline",
      summary:"名前の通り、髪の毛のように細い「線」でツヤを消した仕上げで、マットよりもやや光沢があります。\n" +
        "上品な印象のリングに仕上がります。\n" +
        "薄いつや消しなので、使うとすぐツヤが出てきますが、何度でも当て直しメンテナンスが可能です。",
    },
    {
      id:23,
      step: 4,
      stepJp:"表面の仕上げ",
      name: "ブラシ",
      property: "surface",
      val: "brush",
      summary: '"シンプル"のみで可能。鏡面仕上げまで磨き上げた上から、金属ブラシを使い小傷を入れこなれた風合いを出しています。内側は鏡面仕上げとなります。小傷が目立ちくい仕上がりです。',
    },
    {
      id:24,
      step: 4,
      stepJp:"表面の仕上げ",
      name: "マット",
      property: "surface",
      val: "matte",
      summary:"光沢仕上げの上から、天然石を砕いた砂を当てて小傷を入れる方法で、艶を消ししっとりとした風合いに仕上げたもの。使うごとに艶が出てきますので、表情の変化も楽しめます。当て直しメンテナンスは何度でも無料です。",
    },
  ]
}
